import { useNavigate } from 'react-router-dom';

const quickLinks = [
  { label: '公司介绍 / 회사소개', href: '/about' },
  { label: '推荐商品 / 추천 상품', href: '/#recommended' },
  { label: '最低价商品 / 최저가 상품', href: '/#lowest-price' },
  { label: '热销商品 / 인기 상품', href: '/#popular' },
  { label: '商品搜索 / 상품 검색', href: '/search' },
  { label: '询价咨询 / 상담 문의', href: '/#inquiry' },
];

const categoryLinks = [
  '汤类 / 탕류',
  '海藻类 / 해조류',
  '饮料·豆乳 / 음료·두유',
  '茶类 / 차류',
  '零食·海苔 / 스낵·김',
  '生活用品 / 생활용품',
];

export default function Footer() {
  const navigate = useNavigate();

  const scrollToId = (id: string, delay = 0) => {
    const doScroll = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const bannerHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--banner-height') || '0'
      );
      const headerHeight = 108;
      const offset = bannerHeight + headerHeight;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    };
    if (delay > 0) setTimeout(doScroll, delay);
    else doScroll();
  };

  const handleLink = (href: string) => {
    if (href.startsWith('/#')) {
      const id = href.replace('/#', '');
      if (window.location.pathname !== '/') {
        navigate('/');
        scrollToId(id, 450);
      } else {
        scrollToId(id);
      }
    } else {
      navigate(href);
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  };

  const handleCategoryClick = () => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('categories');
        if (el) {
          const bannerHeight = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--banner-height') || '0'
          );
          const top = el.getBoundingClientRect().top + window.scrollY - (108 + bannerHeight);
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 450);
    } else {
      const el = document.getElementById('categories');
      if (el) {
        const bannerHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--banner-height') || '0'
        );
        const top = el.getBoundingClientRect().top + window.scrollY - (108 + bannerHeight);
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  };

  return (
    <footer style={{ backgroundColor: '#243D30' }}>
      <div className="px-4 md:px-8 lg:px-12 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <button
              onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'instant' }); }}
              className="cursor-pointer mb-4 block"
            >
              <img
                src="https://public.readdy.ai/ai/img_res/3fb26532-6348-47e7-bf78-3e70d3434bf3.png"
                alt="로고"
                className="h-10 w-auto object-contain brightness-200 invert"
              />
            </button>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(248,244,238,0.55)' }}>
              为批发采购商和网络卖家提供食品·化妆品·生活用品等韩国优质商品的B2B专业目录平台。
              <span className="block mt-1 text-xs" style={{ color: 'rgba(248,244,238,0.35)' }}>식품·화장품·생활용품 등 프리미엄 한국 상품을 도매 바이어와 온라인 판매자에게 공급하는 B2B 전문 카탈로그 플랫폼입니다.</span>
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-mail-line', 'ri-phone-line', 'ri-kakao-talk-fill'].map(icon => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full transition-colors cursor-pointer"
                  style={{ backgroundColor: 'rgba(255,255,255,0.08)', color: 'rgba(248,244,238,0.6)' }}
                  onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#C4985A'; (e.currentTarget as HTMLAnchorElement).style.color = '#fff'; }}
                  onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(255,255,255,0.08)'; (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(248,244,238,0.6)'; }}
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-5" style={{ color: '#D9B47A' }}>分类 / 카테고리</h4>
            <ul className="space-y-2.5">
              {categoryLinks.map(cat => (
                <li key={cat}>
                  <button
                    onClick={handleCategoryClick}
                    className="text-sm transition-colors cursor-pointer text-left"
                    style={{ color: 'rgba(248,244,238,0.5)' }}
                    onMouseEnter={e => ((e.currentTarget as HTMLButtonElement).style.color = '#F8F4EE')}
                    onMouseLeave={e => ((e.currentTarget as HTMLButtonElement).style.color = 'rgba(248,244,238,0.5)')}
                  >
                    {cat}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-5" style={{ color: 'rgba(248,244,238,0.55)' }}>快速链接 / 빠른 링크</h4>
            <ul className="space-y-2.5">
              {quickLinks.map(link => (
                <li key={link.href}>
                  <button
                    onClick={() => handleLink(link.href)}
                    className="text-sm transition-colors cursor-pointer text-left"
                    style={{ color: 'rgba(248,244,238,0.5)' }}
                    onMouseEnter={e => ((e.currentTarget as HTMLButtonElement).style.color = '#F8F4EE')}
                    onMouseLeave={e => ((e.currentTarget as HTMLButtonElement).style.color = 'rgba(248,244,238,0.5)')}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-5" style={{ color: 'rgba(248,244,238,0.55)' }}>联系方式 / 연락처</h4>
            <ul className="space-y-3">
              {[
                { icon: 'ri-phone-line', text: '02-300-1234' },
                { icon: 'ri-mail-line', text: 'contact@koreab2b.com' },
                { icon: 'ri-time-line', text: '工作日 09:00–18:00 / 평일 09:00–18:00' },
                { icon: 'ri-map-pin-line', text: '首尔市江南区德黑兰路123号\n서울특별시 강남구 테헤란로 123' },
              ].map(item => (
                <li key={item.icon} className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                    <i className={`${item.icon} text-sm`} style={{ color: 'rgba(248,244,238,0.35)' }}></i>
                  </div>
                  <span className="text-sm whitespace-pre-line" style={{ color: 'rgba(248,244,238,0.5)' }}>{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t px-4 md:px-8 lg:px-12 py-5" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: 'rgba(248,244,238,0.3)' }}>© 2026 Korea B2B Supply. All rights reserved.</p>
          <div className="flex items-center gap-4">
            {['隐私政策 / 개인정보처리방침', '使用条款 / 이용약관', '企业信息 / 사업자정보'].map(label => (
              <a
                key={label}
                href="#"
                rel="nofollow"
                className="text-xs transition-colors cursor-pointer"
                style={{ color: 'rgba(248,244,238,0.3)' }}
                onMouseEnter={e => ((e.currentTarget as HTMLAnchorElement).style.color = 'rgba(248,244,238,0.7)')}
                onMouseLeave={e => ((e.currentTarget as HTMLAnchorElement).style.color = 'rgba(248,244,238,0.3)')}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
